import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ResetPasswordComponent} from './shared/components/auth/reset-password/reset-password.component';
import {ForgotPasswordComponent} from './shared/components/auth/forgot-password/forgot-password.component';
import {LandingPageComponent} from './shared/components/auth/landing-page/landing-page.component';
import {RegistrationComponent} from './shared/components/auth/registration/registration';
import {VerifyEmailComponent} from './shared/components/auth/verify-email/verify-email.component';
import {VerifyEmailPendingComponent} from './shared/components/auth/verify-email-pending/verify-email-pending.component';
import {PrivacyPolicyComponent} from './shared/components/legal/privacy-policy/privacy-policy.component';
import {AccountDeletionComponent} from './shared/components/legal/account-deletion/account-deletion.component';
import {TermsOfServiceComponent} from './shared/components/legal/terms-of-service/terms-of-service.component';
import { HomeLayoutComponent } from './shared/components/layouts/home-layout/home-layout.component';
import { FirmRegisteredComponent } from './shared/components/auth/firm-registered/firm-registered.component';
import {AuthGuard} from './shared/guards/auth.guard';
import { ExternalUserLayoutComponent } from './shared/components/layouts/external-user-layout/external-user-layout.component';
import { StaffSidebarComponent } from './shared/components/layouts/staff/staff-sidebar/staff-sidebar.component';

const routes: Routes = [
  { path: '', redirectTo: '/landing', pathMatch: 'full'},
  { path: 'login', redirectTo: '/landing', pathMatch: 'full'},
  { path: 'sign-up', redirectTo: '/landing', pathMatch: 'full'},
  { path: 'registration', component: RegistrationComponent},
  { path: 'verify-email', component: VerifyEmailComponent},
  { path: 'verify-email-pending', component: VerifyEmailPendingComponent},
  { path: 'privacy-policy', component: PrivacyPolicyComponent},
  { path: 'terms-of-service', component: TermsOfServiceComponent},
  { path: 'delete-account', component: AccountDeletionComponent},
  { path: 'landing', component: LandingPageComponent, canActivate: []},
  { path: 'forgot-password', component: ForgotPasswordComponent},
  { path: 'reset-password', component: ResetPasswordComponent},
  { path: 'home', component: HomeLayoutComponent, canActivate: []},
  { path: 'registered-firms', component: FirmRegisteredComponent, canActivate: []},
  {
    path: 'dashboard',
    component: StaffSidebarComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'online-layout',
    redirectTo: '/online',
    pathMatch: 'full'
  },
  {
    path: 'users',
    loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule),
    canActivate: [AuthGuard],
  },

  {
    path: 'main-dashboard',
    loadChildren: () => import('./modules/main-dashboard/main-dashboard.module').then(m => m.MainDashboardModule),
    canActivate: [AuthGuard],
  },

  {
    path: 'invetory',
    loadChildren: () => import('./modules/invetory-management/invetory-management.module').then(m => m.InvetoryManagementModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'expenses',
    loadChildren: () => import('./modules/expenses/expenses.module').then(m => m.ExpensesModule),
    canActivate: [AuthGuard],
  },
   {
    path: 'report',
    loadChildren: () => import('./modules/report/report.module').then(m => m.ReportModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'orders',
    loadChildren: () => import('./modules/orders/orders.module').then(m => m.OrdersModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'billing',
    loadChildren: () => import('./modules/billing/billing.module').then(m => m.BillingModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'notifications',
    loadChildren: () => import('./modules/notifications/notifications.module').then(m => m.NotificationsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      // relativeLinkResolution: 'legacy',
      onSameUrlNavigation: 'reload'
    }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
